export default __webpack_public_path__ + "media/ae25d64d1b9d9b6bdd170562661e2169d0556ec2a2173dd4986f447ea65afea8.svg";